import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import MyFavouriteDropDown from './MyFavouriteDropDown';
import DeleteMusicModal from './DeleteMusicModal';
import '../../Styles/deleteartModal.css';
import EditMusicDetails from './uploadMusicFile/EditMusicDetails';
import { useDispatch } from 'react-redux';
import { ConfirmDeleteUserSound, DownloadMusic, getArtDetails, getUserSound } from '../../redux/features/auth/authSlice';
import EditUserUploadArt from '../../Screens/UserDashboard/UserUploadArt/EditUserUploadArt';
import DeleteArtModal from './DeleteArtModal';
import axios from 'axios';
import { baseURL } from '../../redux/axios/axios';
const SelectedBoxOptions = ({ selectedCheckboxes, currentTab, check, selectedItemsObject,title }) => {
console.log("🚀 ~ SelectedBoxOptions ~ title:", title)


  const [deleteArtOpen, setDeleteArtOpen] = useState(false);
  const [editArtOpen, setEditArtOpen] = useState(false);
  const [confirmData, setConfirmData] = useState([]);
  const [userartdata, setuserartdata] = useState()
  const [downloadLoading, setDownloadLoading] = useState(false);



  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user"));
  const user_id = user?.user[0]._id;

  const deleteArtOpenScreen = async () => {
    if (currentTab === 'Artwork') {
      await dispatch(getArtDetails(selectedCheckboxes))
        .then((res) => {
          setuserartdata(res?.payload?.data)
          setDeleteArtOpen(!deleteArtOpen);
        })


    }
    else {
      const ConfirmData = await dispatch(ConfirmDeleteUserSound({ soundIds: selectedCheckboxes }));
      await dispatch(getUserSound({
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        user_id,
      })
      );
      setConfirmData(ConfirmData.payload.sounds);
      setDeleteArtOpen(!deleteArtOpen);
    }


  };



  const editArtOpenScreen = () => {
    setEditArtOpen(!editArtOpen);
  };

  const download = async () => {
    try {
      setDownloadLoading(true);

      const USER = JSON.parse(localStorage.getItem("user"));
      const token = USER?.token;
      const downloadPromises = selectedItemsObject.itemIds.map(async (soundId) => {
        return axios.post(`${baseURL}/art/downloads/file`, {
          itemIds: [soundId],
          fileType: selectedItemsObject.fileType
        }, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      });

      const responses = await Promise.all(downloadPromises);

      responses.forEach((response) => {
        const blob = new Blob([response.data]);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${title}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (error) {
      console.error('Failed to download sounds:', error);
    } finally {
      setDownloadLoading(false);
    }
  };


  useEffect(() => {
    if (selectedCheckboxes?.length === 0) {
      setDeleteArtOpen(false);
      setEditArtOpen(false);
    }
  }, [selectedCheckboxes]);

  return (
    <>
      {selectedCheckboxes?.length > 0 && (
        <div className="container-fluid text-center align-items-center py-2 text-white" style={{ background: '#74A8B0' }}>
          <div className="selectbox ">
            <div className=" border-end boxes">
            <div>
               <p className="ps-1 mb-0">  <span className="text-white" style={{ borderRadius: '10px' }}>
                {selectedCheckboxes ? selectedCheckboxes?.length : 'Selected'}
              </span> Selected</p>
            </div>
             
            </div>
            {/* {
              check === false ? <p className='  boxes'></p> : (
                <div className=" border-end boxes">
                  <MyFavouriteDropDown selectedCheckboxes={selectedCheckboxes} />
                </div>
              )
            } */}
            <div className=" border-end boxes">
                  <MyFavouriteDropDown selectedCheckboxes={selectedCheckboxes} />
                </div>
            <div type="button" onClick={editArtOpenScreen} className=" border-end boxes">
              <div className="d-flex">
              <div className="d-flex align-items-center justify-content-center">
                <FontAwesomeIcon icon={faPenToSquare} className='ps-2 selecboxicon' /> 
              </div>
                
                 <p className="ps-2  mb-0">Edit Details</p>
              </div>
            
            </div>

            <div className="border-end boxes" type="button" onClick={download}>
              <div className="d-flex">
                {downloadLoading ? (
                  /* You can replace this with your own spinner component */
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (<>
                 <div className="d-flex align-items-center justify-content-center">
                     <FontAwesomeIcon icon={faDownload} className='ps-2 selecboxicon' />
                 </div>
              
                   <p className="ps-2  mb-0">{downloadLoading ? 'Downloading...' : 'Download'}</p>
                </>
                 
                )}
              </div>
            
            </div>

            <div type="button" onClick={deleteArtOpenScreen} className="boxes">
              <div className="d-flex">
                <div className="d-flex align-items-center justify-content-center">
                  < FontAwesomeIcon icon={faTrashCan} className='ps-2 selecboxicon' /> 
                </div>
               
                <p className="ps-2  mb-0">Delete</p>
              </div>
             
            </div>
          </div>
        </div>
      )}

      {deleteArtOpen && (
        <div className="modalFordeleteArtOpen">
          <div className="modal-contentFordeleteArtOpen">
            {currentTab === 'Artwork' ?
              <DeleteArtModal closeWindow={deleteArtOpenScreen} confirmData={userartdata} />
              :
              <DeleteMusicModal closeWindow={deleteArtOpenScreen} confirmData={confirmData} />
            }

          </div>
        </div>
      )}

      {editArtOpen && (
        <div className="modalForUpdateArtOpen">
          <div className="modal-contentForUpdateArtOpen">
            {currentTab === 'Artwork' ? (
              <EditUserUploadArt closeWindow={editArtOpenScreen} selectedCheckboxes={selectedCheckboxes} />
            ) : (
              <EditMusicDetails closeWindow={editArtOpenScreen} selectedCheckboxes={selectedCheckboxes} />
            )}
          </div>
        </div>
      )}


    </>
  );
};

export default SelectedBoxOptions;
